import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || "";

Sentry.init({
	dsn: SENTRY_DSN,
	sendDefaultPii: true,
	integrations: [browserTracingIntegration()],
	tracesSampleRate: 0.1,
});

const rootElement = document.getElementById("root");
if (rootElement) {
	ReactDOM.createRoot(rootElement).render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	);
}
